export class KYMW9101InputModel {
  /* ログ検索するテーブル */
  /* 商品マスタ：１、企画マスタ：２、指定しない：３ */
  public searchTableCondition: number;
  /* 受注コード */
  public orderCode: string = <string>'';
  /* いばらきコード */
  public coopIbarakiCode: string = <string>'';
  /* とちぎコード */
  public coopTochigiCode: string = <string>'';
  /* ぐんまコード */
  public coopGunmaCode: string = <string>'';
  /* ちばコード */
  public coopChibaCode: string = <string>'';
  /* さいたまコード */
  public coopSaitamaCode: string = <string>'';
  /* とうきょうコード */
  public coopTokyoCode: string = <string>'';
  /* ながのコード */
  public coopNaganoCode: string = <string>'';
  /* にいがたコード */
  public coopNiigataCode: string = <string>'';
  /* クルココード */
  public coopKurucoCode: string = <string>'';
  /* Pコード */
  public pcode: string = <string>'';
  /* アイテムコード */
  public itemCode: string = <string>'';
  /* ユーザーID */
  public userID: string = <string>'';
  /* 期間指定 */
  public selectDuration: boolean = <boolean>false;
  /* 更新日From */
  public updateDateFrom: string = <string>'';
  /* 更新日To */
  public updateDateTo: string = <string>'';
}